



























































import mixins from 'vue-typed-mixins';
import { DataTableHeader } from 'vuetify';
import { Permission, User } from '@/utils/UserUtils';
import cloneDeep from 'lodash.clonedeep';
import UserPermissionForm from './UserPermissionForm.vue';
export default mixins().extend({
  components: {
    UserPermissionForm,
  },
  props: {
    value: {
      type: Object as () => Partial<User>,
    },
  },
  computed: {
    headers(): DataTableHeader<Permission>[] {
      return [
        { text: this.$i18n.tc('model.role.label'), value: 'role.name' },
        {
          text: this.$i18n.tc('model.oversightOrganization.label'),
          value: 'oversight.name',
        },
        {
          text: this.$i18n.tc('model.serviceProvider.label'),
          value: 'serviceprovider.name',
        },
      ];
    },
  },
  data(): {
    search: string;
    permissions: Partial<Permission>[];
    permission?: Partial<Permission>;
    index?: number;
    modal: boolean;
  } {
    return {
      search: '',
      permissions: cloneDeep(this.value.permissions) || [],
      permission: undefined,
      index: undefined,
      modal: false,
    };
  },
  methods: {
    create() {
      this.permission = {
        role: undefined,
        oversight: undefined,
        serviceprovider: undefined,
      };
      this.index = undefined;
      this.modal = true;
    },
    edit(permission: Permission) {
      this.permission = cloneDeep(permission);
      this.index = this.permissions?.findIndex((val) => val === permission);
      this.modal = true;
    },
    remove(permission: Permission) {
      if (this.permissions) {
        const index = this.permissions.findIndex((val) => val === permission);
        if (index >= 0) {
          this.permissions?.splice(index, 1);
        }
        this.permissions = Array.from(this.permissions);
        this.value.permissions = this.permissions;
        this.$emit('input', this.value);
      }
    },
    submit() {
      if (this.permission && this.permissions) {
        if (this.index !== undefined) {
          this.permissions[this.index] = this.permission;
        } else {
          this.permissions.push(this.permission);
        }
        this.permissions = Array.from(this.permissions);
        this.value.permissions = this.permissions;
        this.$emit('input', this.value);
      }
      this.modal = false;
    },
  },
});
